var _effectorFileName = "/src/features/quiz/components/quiz-result.tsx";
import React from 'react';
import { cn } from '@/shared/lib/cn';
interface QuizResultHeaderProps {
  className?: string;
  children?: React.ReactNode;
}
export const QuizResultHeader = React.forwardRef<HTMLDivElement, QuizResultHeaderProps>(({
  className,
  children,
  ...props
}, ref) => {
  return <div ref={ref} className={cn('mb-4 text-center sm:mb-8', className)} {...props}>
        {children}
      </div>;
});
QuizResultHeader.displayName = 'QuizResultHeader';